"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupedHistoryRewardsList = void 0;
const _ = __importStar(require("lodash"));
const TimeUtil_1 = require("../../utils/TimeUtil");
class GroupedHistoryRewardsList extends Array {
    constructor() {
        super(...arguments);
        this.createGroupedList = (rewards) => {
            const groupedRewards = new GroupedHistoryRewardsList();
            _.forEach(_.mapValues(_.groupBy(rewards, 'reward_id')), rewardGroup => {
                const drawDate = rewardGroup[0].extra_data && rewardGroup[0].extra_data.draw_date;
                let referenceDate;
                let displayDate;
                if (!drawDate) {
                    const latestActivity = _.maxBy(rewardGroup, 'date_created');
                    referenceDate = this.getReferenceDateFromLatestActivity(latestActivity);
                    displayDate = (0, TimeUtil_1.formatUnixMonthOrdinalDayYear)(referenceDate);
                }
                else {
                    referenceDate = Math.round((0, TimeUtil_1.parseLocalISOString)(drawDate).getTime() / 1000);
                    displayDate = (0, TimeUtil_1.formatLocalUnixMonthOrdinalDayYear)(referenceDate);
                }
                rewardGroup.forEach(x => {
                    x.dateCreated = (0, TimeUtil_1.formatUnixLongMonthDayCommaYearHourTime)(/^-?\d+$/.test(x.date_created)
                        ? parseInt(x.date_created, 10)
                        : (0, TimeUtil_1.formatTimeStampToUnixMonthOrdinalDayYear)(x.date_created));
                });
                groupedRewards.push({ referenceDate, displayDate, rewards: rewardGroup });
            });
            return _.orderBy(groupedRewards, 'referenceDate', 'desc');
        };
    }
    getReferenceDateFromLatestActivity(latestActivity) {
        if (latestActivity && /^-?\d+$/.test(latestActivity.date_created)) {
            return parseInt(latestActivity.date_created, 10);
        }
        return latestActivity
            ? (0, TimeUtil_1.formatTimeStampToUnixMonthOrdinalDayYear)(latestActivity.date_created)
            : 0;
    }
}
exports.GroupedHistoryRewardsList = GroupedHistoryRewardsList;
//# sourceMappingURL=GroupedHistoryRewardsList.js.map